import { createContextEvent } from '../create-custom-event';

export const LANGUAGE_PICKER_AVAILABILITY_CHANGE_ACTION = 'platform-language-picker-availability-change' as const;
export type LanguagePickerAvailabilityChangeAction = typeof LANGUAGE_PICKER_AVAILABILITY_CHANGE_ACTION;

export interface ILanguagePickerAvailabilityChangeAction {
  available: boolean;
}

export type LanguagePickerAvailabilityChangeEvent = CustomEvent<ILanguagePickerAvailabilityChangeAction>;

export function createLanguagePickerAvailabilityChangeEvent(available: boolean): LanguagePickerAvailabilityChangeEvent {
  return createContextEvent({
    eventType: LANGUAGE_PICKER_AVAILABILITY_CHANGE_ACTION,
    eventDetail: { available },
  });
}
